export default __webpack_public_path__ + "static/media/entenda_5_parafuso.20a1854b.jpg";